import T from 'prop-types';
import React from 'react';
import { Episode, MediaFile, Show } from 'resources';
import Container from 'shared/components/content-container';
import resourceProp from 'shared/helpers/resource-prop';
import DeleteEpisode from './delete-episode';
import RSSSettings from './rss-settings';
import BasicInfo from './basic-info';
import { markerPropType } from '../../../customPropTypes';

const BasicInfoView = (props, context) => {
  const { episode, show, markers, mediaFile, retryEncoder, hasMediaFileError } = context;

  return (
    <Container>
      <BasicInfo
        episode={episode}
        markers={markers}
        mediaFile={mediaFile}
        retryEncoder={retryEncoder}
        hasMediaFileError={hasMediaFileError}
      />
      <RSSSettings episode={episode} show={show} />
      <DeleteEpisode episode={episode} />
    </Container>
  );
};

BasicInfoView.propTypes = {};

BasicInfoView.contextTypes = {
  episode: resourceProp(Episode),
  show: resourceProp(Show),
  markers: T.arrayOf(markerPropType),
  mediaFile: resourceProp(MediaFile),
  retryEncoder: T.func,
  hasMediaFileError: T.bool,
};

export default BasicInfoView;
